export function parseDisplayName(displayName: any): { text: string } | null {
  if (!displayName) return null;
  if (typeof displayName === 'object' && 'text' in displayName) return displayName;

  try {
    if (typeof displayName === 'string') {
      const parsed = JSON.parse(displayName);
      if (parsed && typeof parsed === 'object' && 'text' in parsed) {
        return parsed as { text: string };
      }
    }
  } catch {
    // fall through
  }

  if (typeof displayName === 'string') {
    return { text: displayName };
  }

  return null;
}

export function interpolate(text: string, vars: Record<string, string>): string {
  return text.replace(/{([a-zA-Z0-9_]+)}/g, (match, key) => {
    return vars[key] !== undefined ? vars[key] : match;
  });
}

export function formatDate(value: string | Date): string {
  const date = value instanceof Date ? value : new Date(value);
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}
